// Bulgarian translations — CityDates i18n
// To add a new language: copy this file, rename to [lang].ts, translate all values

const bg = {
  // App
  app: {
    name: 'CityDates',
    tagline: 'Реални срещи в български градове',
  },

  // Auth
  auth: {
    login: 'Вход',
    register: 'Регистрация',
    email: 'Имейл адрес',
    password: 'Парола',
    yourName: 'Твоето име',
    enterGame: 'Влез в играта',
    createAccount: 'Създай акаунт',
    continueWithGoogle: 'Продължи с Google',
    or: 'или',
    testAccounts: 'Тестови акаунти',
    termsNote: 'Влизайки, приемаш нашите Условия за ползване',
    welcomeBack: 'Добре дошъл обратно!',
    accountCreated: 'Акаунтът е създаден! Добре дошъл в CityDates!',
    fillAllFields: 'Моля, попълни всички полета.',
    enterName: 'Въведи своето име.',
    wrongCredentials: 'Грешен имейл или парола.',
    emailExists: 'Вече съществува акаунт с този имейл.',
    googleError: 'Грешка при Google вход: ',
    loginError: 'Грешка при вход.',
  },

  // Navigation
  nav: {
    play: 'Играй',
    social: 'Социално',
    cityMap: 'Карта на града',
    checkIn: 'Настоящо място',
    location: 'Локация',
    chat: 'Чат',
    discovery: 'Открий играчи',
    profile: 'Профил',
    likes: 'Харесвания',
    credits: 'Кредити',
    buyCredits: '+ Купи кредити',
    notifications: 'Известия',
    settings: 'Настройки',
    logout: 'Изход',
    logoutSuccess: 'Излязохте успешно.',
    logoutError: 'Грешка при изход.',
    mood: 'Настроение',
    money: 'Пари',
    energy: 'Енергия',
    online: 'Онлайн',
  },

  // Character creation
  character: {
    step: 'Стъпка',
    of: 'от',
    makeChoice: 'Моля, направи избор преди да продължиш.',
    next: 'Напред',
    back: 'Назад',
    create: 'Създай персонаж',
    creating: 'Създаване...',
    created: 'Персонажът е създаден! Добре дошъл в CityDates!',
    enterName: 'Въведи името на персонажа си.',

    // Step gender
    whoIsYourChar: 'Кой е твоят персонаж?',
    genderDesc: 'Изборът на пол определя облеклото, прическите и социалната динамика на персонажа ти.',
    male: 'Мъж',
    female: 'Жена',
    maleDesc: 'Мъжки персонаж с мъжки облекла, прически и социална динамика',
    femaleDesc: 'Женски персонаж с женски облекла, прически и социална динамика',
    genderNote: '💡 Изборът на пол не ограничава с кого се срещаш — това се задава в следващата стъпка.',

    // Step orientation
    whoDoYouLike: 'Кого харесваш?',
    orientationDesc: 'Изборът определя кои профили ще виждаш в играта.',
    men: 'Мъже',
    women: 'Жени',
    both: 'И двете',

    // Step city
    chooseCity: 'В кой град живееш?',
    cityDesc: 'Градът определя картата, локациите и играчите около теб.',

    // Step life profile
    whatIsLife: 'Какъв е животът на персонажа ти?',
    lifeProfileDesc: 'Профилът не е само козметичен — определя пари, работа, стил, увереност и социална среда.',
    pointBudget: 'Точков бюджет',
    pointsLeft: 'оставащи точки',
    pointsOver: 'надвишени точки',
    resetStats: 'Нулирай',
    appearance: 'Привлекателност',
    budget: 'Бюджет',
    social: 'Социалност',
    career: 'Кариера',

    // Step avatar
    createVisual: 'Създай визуалния си персонаж',
    avatarDesc: 'Настрой как изглежда твоят персонаж. Можеш да промениш всичко по-късно.',
    uploadPhoto: 'Качи снимка',
    uploadPhotoDesc: 'Качи своя снимка и AI ще генерира аватар, който прилича на теб',
    analyzePhoto: 'Анализирай снимката',
    analyzing: 'Анализиране...',
    generatingAvatar: 'Генериране на аватар...',
    avatarGenerated: 'Аватарът е генериран!',
    photoAnalyzed: 'Снимката е анализирана! Генерираме аватар...',
    uploadError: 'Грешка при качване на снимката.',
    hair: 'Коса',
    body: 'Тяло',
    features: 'Черти',
    height: 'Ръст',
    hairStyle: 'Прическа',
    hairColor: 'Цвят на косата',
    bodyType: 'Тип тяло',
    skinTone: 'Тен на кожата',
    eyeColor: 'Цвят на очите',
    facialFeatures: 'Характерни черти (избери до 2)',
    heightLabel: 'Височина',
    cm: 'сантиметра',
    charPreview: 'Преглед на персонажа',
    chooseAbove: 'Избери характеристики по-горе',

    // Step confirm
    confirmTitle: 'Потвърди персонажа',
    charName: 'Име на персонажа',
    charAge: 'Възраст',
    years: 'години',
  },

  // City map
  cityMap: {
    title: 'Карта на града',
    searchLocation: 'Търси локация...',
    playersIn: 'Играчи в',
    playersInVarna: 'Играчи във Варна',
    playersInSofia: 'Играчи в София',
    playersInPlovdiv: 'Играчи в Пловдив',
    playersInBurgas: 'Играчи в Бургас',
    open: 'Отворено',
    closed: 'Затворено',
    players: 'играчи',
    male: 'мъже',
    female: 'жени',
    enterLocation: 'Влез в локацията',
    weather: 'Времето',
    events: 'Събития',
    noEvents: 'Няма активни събития',
    loadingWeather: 'Зареждане...',
  },

  // Location types
  locationTypes: {
    disco: 'Дискотека',
    bar: 'Бар',
    restaurant: 'Ресторант',
    library: 'Библиотека',
    park: 'Парк',
    cinema: 'Кино',
    theater: 'Театър',
    cafe: 'Кафе',
    mall: 'Мол',
    beach: 'Плаж',
    club: 'Клуб',
    landmark: 'Забележителност',
    museum: 'Музей',
    gallery: 'Галерия',
    stadium: 'Стадион',
  },

  // Location screen
  location: {
    backToMap: 'Карта на',
    openNow: 'Отворено',
    closedNow: 'Затворено',
    peopleHere: 'Хора тук',
    scenarios: 'Сценарии',
    info: 'Информация',
    createSituation: 'Създай ситуация',
    inviteToMeeting: 'Покани на среща',
    workingHours: 'Работно време',
    status: 'Статус',
    avgPrice: 'Средна цена за двама',
    dresscode: 'Дрескод',
    noise: 'Шум',
    capacity: 'Капацитет',
    petsAllowed: 'Позволени животни',
    voiceChat: 'Гласов чат',
    goodForFirstDate: 'Подходящо за първа среща',
    workingHoursByType: 'Работно време по тип локация',
    here: 'тук',
  },

  // Chat
  chat: {
    title: 'Съобщения',
    typeMessage: 'Напиши съобщение...',
    send: 'Изпрати',
    aiAdvisor: 'AI Съветник',
    voiceCall: 'Гласово обаждане',
    endCall: 'Прекрати обаждането',
    calling: 'Обаждане...',
    inCall: 'В разговор',
    micOn: 'Микрофон включен',
    micOff: 'Микрофон изключен',
    callEnded: 'Разговорът приключи',
    callError: 'Грешка при обаждането',
  },

  // Notifications
  notifications: {
    title: 'Известия',
    noNotifications: 'Няма известия',
    markAllRead: 'Маркирай всички',
    newLike: 'Ново харесване!',
    newMessage: 'Ново съобщение',
    welcome: 'Добре дошъл!',
  },

  // Settings
  settings: {
    title: 'Настройки',
    subtitle: 'Управлявай своя акаунт и предпочитания',
    account: 'Акаунт',
    accountDesc: 'Обнови своето публично профилно информация',
    displayName: 'Показвано име',
    email: 'Имейл адрес',
    emailReadOnly: 'Имейлът не може да се промени.',
    bio: 'Кратко представяне',
    bioPlaceholder: 'Разкажи нещо за себе си...',
    notificationsSection: 'Известия',
    notificationsDesc: 'Контролирай кога и как получаваш известия',
    channels: 'Канали',
    notifTypes: 'Типове известия',
    privacy: 'Поверителност',
    gameNotifications: 'Известия в играта',
    gameNotificationsDesc: 'Системни и игрови известия',
    emailNotifications: 'Имейл известия',
    emailNotificationsDesc: 'Получавай известия по имейл',
    soundEffects: 'Звукови ефекти',
    soundEffectsDesc: 'Звуци при нови съобщения и харесвания',
    matchNotifs: 'Нови харесвания',
    matchNotifsDesc: 'Когато някой те хареса',
    messageNotifs: 'Съобщения',
    messageNotifsDesc: 'Нови чат съобщения',
    eventNotifs: 'Събития и куестове',
    eventNotifsDesc: 'Нови предизвикателства и сезонни събития',
    onlineStatus: 'Онлайн статус',
    profileVisibility: 'Видимост на профила',
    public: '🌍 Публичен',
    friends: '👥 Приятели',
    private: '🔒 Частен',
    password: 'Парола',
    passwordDesc: 'Актуализирай паролата за своя акаунт',
    currentPassword: 'Текуща парола',
    newPassword: 'Нова парола',
    newPasswordHint: 'Минимум 6 символа',
    confirmPassword: 'Потвърди новата парола',
    passwordTip: 'Паролата трябва да е поне 6 символа. Използвай комбинация от букви, цифри и специални знаци за по-добра сигурност.',
    changePassword: 'Смени паролата',
    language: 'Език',
    languageDesc: 'Избери предпочитания език на интерфейса',
    applyLanguage: 'Приложи езика',
    danger: 'Опасна зона',
    dangerDesc: 'Необратими действия с твоя акаунт',
    deleteAccount: 'Изтрий акаунта',
    deleteAccountDesc: 'Изтриването на акаунта е необратимо. Всички твои данни, прогрес, постижения и история ще бъдат изтрити завинаги.',
    deleteAccountBtn: 'Изтрий акаунта ми',
    deleteConfirmLabel: 'Въведи ИЗТРИЙ за потвърждение',
    deleteForever: 'Изтрий завинаги',
    deleting: 'Изтриване...',
    signOut: 'Изход от акаунта',
    signOutDesc: 'Излез от текущата сесия на всички устройства.',
    signOutBtn: 'Излез от акаунта',
    save: 'Запази промените',
    saveNotifs: 'Запази предпочитанията',
    saved: 'Настройките са запазени!',
    accountUpdated: 'Акаунтът е обновен успешно!',
    passwordChanged: 'Паролата е сменена успешно!',
    languageApplied: 'Езикът е зададен успешно.',
    saveError: 'Грешка при запазване.',
    passwordError: 'Грешка при смяна на паролата.',
    passwordMismatch: 'Паролите не съвпадат.',
    passwordTooShort: 'Паролата трябва да е поне 6 символа.',
    fillAllFields: 'Попълни всички полета.',
    enterValidName: 'Въведи валидно име.',
    cancel: 'Отказ',
  },

  // Profile
  profile: {
    rating: 'Рейтинг',
    reviews: 'отзива',
    leaveReview: 'Остави отзив',
    traits: 'Характеристики',
    memories: 'Спомени',
    attraction: 'Привличане',
  },

  // Situations
  situations: {
    createTitle: 'Създай ситуация',
    createDesc: 'Опиши ситуация, в която искаш да се окажеш с друг играч',
    inviteTitle: 'Покани на среща',
    inviteDesc: 'Изпрати покана за среща на друг играч',
    situationType: 'Тип ситуация',
    message: 'Съобщение',
    send: 'Изпрати',
    cancel: 'Отказ',
    sent: 'Поканата е изпратена!',
    types: {
      coffee: '☕ Кафе',
      walk: '🚶 Разходка',
      dinner: '🍽️ Вечеря',
      cinema: '🎬 Кино',
      concert: '🎵 Концерт',
      spontaneous: '⚡ Спонтанно',
    },
  },

  // Bulgarian grammar helpers
  grammar: {
    // Prepositions for cities
    inCity: {
      varna: 'във Варна',
      sofia: 'в София',
      plovdiv: 'в Пловдив',
      burgas: 'в Бургас',
    },
    // Gender-specific adjectives
    adjectives: {
      beautiful: { male: 'красив', female: 'красива' },
      poor: { male: 'беден', female: 'бедна' },
      smart: { male: 'умен', female: 'умна' },
      rich: { male: 'богат', female: 'богата' },
      cold: { male: 'студен', female: 'студена' },
      ambitious: { male: 'амбициозен', female: 'амбициозна' },
      busy: { male: 'зает', female: 'заета' },
      fun: { male: 'забавен', female: 'забавна' },
      unreliable: { male: 'ненадежден', female: 'ненадеждна' },
      family: { male: 'семеен', female: 'семейна' },
      caring: { male: 'грижовен', female: 'грижовна' },
      athletic: { male: 'спортен', female: 'спортна' },
      disciplined: { male: 'дисциплиниран', female: 'дисциплинирана' },
      artistic: { male: 'артистичен', female: 'артистична' },
      emotional: { male: 'емоционален', female: 'емоционална' },
      shy: { male: 'срамежлив', female: 'срамежлива' },
      sincere: { male: 'искрен', female: 'искрена' },
      thin: { male: 'слаб', female: 'слаба' },
      average: { male: 'среден', female: 'средна' },
      athletic2: { male: 'атлетичен', female: 'атлетична' },
      large: { male: 'едър', female: 'едра' },
    },
  },

  // Dating History
  datingHistory: {
    title: 'История на срещите',
    subtitle: 'Всички твои минали срещи, резултати и статуси',
    totalDates: 'Общо срещи',
    romantic: 'Романтични',
    active: 'Активни',
    avgRating: 'Среден рейтинг',
    outcomes: 'Резултати',
    topLocations: 'Любими локации',
    avgCompatibility: 'Средна съвместимост',
    filterAll: 'Всички',
    filterRomantic: 'Романтични',
    filterOngoing: 'Продължават',
    filterFriendly: 'Приятелски',
    filterFailed: 'Неуспешни',
    noResults: 'Няма срещи в тази категория',
    noResultsDesc: 'Промени филтъра, за да видиш повече',
    dateDetails: 'Детайли за срещата',
    location: 'Локация',
    date: 'Дата',
    compatibility: 'Съвместимост',
    notes: 'Бележки',
    highlight: 'Запомняща',
    statTitle: 'Статистика',
  },

  // Discovery
  discovery: {
    title: 'Открий играчи',
    subtitle: 'съвместими играча намерени',
    swipeView: 'Свайп',
    listView: 'Списък',
    filters: 'Филтри',
    applyFilters: 'Приложи филтрите',
    filterTitle: 'Филтри за търсене',
    city: 'Град',
    gender: 'Пол',
    allCities: 'Всички',
    allGenders: 'Всички',
    men: 'Мъже',
    women: 'Жени',
    ageRange: 'Възраст',
    minRating: 'Минимален рейтинг',
    allRatings: 'Всички',
    interests: 'Интереси',
    openToTalk: 'Само отворени за разговор',
    compatibility: 'съвместимост',
    sortBy: 'Сортирай по',
    sortCompatibility: 'По съвместимост',
    sortRating: 'По рейтинг',
    sortAge: 'По възраст',
    liked: 'харесани',
    skipped: 'пропуснати',
    remaining: 'останали',
    swipeRight: 'Плъзни надясно за харесване · Плъзни наляво за пропускане',
    likeBtn: 'Харесай',
    likedBtn: 'Харесан/а',
    skipBtn: 'Пропусни',
    undoBtn: 'Върни',
    resetDeck: 'Нулирай колодата',
    toMap: 'Към картата',
    allSeen: 'Разгледа всички!',
    allSeenDesc: 'Промени филтрите или нулирай колодата.',
    noPlayers: 'Няма намерени играчи',
    noPlayersDesc: 'Промени филтрите, за да видиш повече резултати.',
    likedToast: 'Харесал/а си',
    openToTalkBadge: 'Отворен/а',
    viewProfile: 'Виж пълния профил →',
  },

  // Challenges
  challenges: {
    title: 'Предизвикателства',
    subtitle: 'Изпълни куестове, спечели награди, изкачи класацията',
    season: 'Сезон: Пролет',
    seasonEnds: 'Завършва след 12 дни',
    seasonXp: 'Сезонен XP',
    level: 'Ниво',
    tabs: {
      quests: 'Куестове',
      streak: 'Серии',
      leaderboard: 'Класация',
      rewards: 'Награди',
    },
    quests: {
      daily: 'Дневни куестове',
      seasonal: 'Сезонни куестове',
      all: 'Всички',
      completed: 'завършени',
      difficulty: {
        easy: 'Лесно',
        medium: 'Средно',
        hard: 'Трудно',
        legendary: 'Легендарно',
      },
    },
    streak: {
      title: 'Серия',
      days: 'поредни дни',
      longest: 'Най-дълга серия',
      thisWeek: 'Тази седмица',
      milestones: 'Серийни награди',
      daysLeft: 'дни',
    },
    leaderboard: {
      weekly: 'Седмична',
      seasonal: 'Сезонна',
      alltime: 'Всички времена',
      yourRank: 'Твоята позиция',
      full: 'Пълна класация',
    },
    rewards: {
      dailyTitle: 'Дневни награди за вход',
      seasonTitle: 'Сезонни награди',
      claim: 'Вземи',
      claimed: 'Взета',
      tiers: {
        bronze: 'Бронз',
        silver: 'Сребро',
        gold: 'Злато',
        platinum: 'Платина',
      },
    },
  },

  // Achievements
  achievements: {
    title: 'Постижения',
    subtitle: 'отключени постижения',
    unlocked: 'Отключени',
    locked: 'Заключени',
    xpEarned: 'XP спечелени',
    legendary: 'Легендарни',
    allCategories: 'Всички',
    nextGoals: 'Следващи цели',
    rarityLegend: 'Рядкост на значките',
    unlockedOn: 'Отключено на',
    xpReward: 'XP награда',
    progress: 'Прогрес',
    categories: {
      dates: 'Срещи',
      matches: 'Харесвания',
      social: 'Социално',
      exclusive: 'Изключителни',
      special: 'Специални',
    },
    rarity: {
      common: 'Обикновено',
      rare: 'Рядко',
      epic: 'Епично',
      legendary: 'Легендарно',
    },
  },
};

export type TranslationKeys = typeof bg;
export default bg;
